import { PreviousApprovedVersion } from "@design-controls/types";
import { toDesignElementVersionLabel } from "../../domain/designElementVersion";

type ReviewItem = {
  version: string;
  major?: number | null;
  minor?: number | null;
  previousApprovedVersion?: PreviousApprovedVersion | null;
};

export const reviewItemComparePath = (item: ReviewItem): string | undefined => {
  if (!item.previousApprovedVersion) {
    return undefined;
  }

  const { major, minor } = item.previousApprovedVersion;
  return `/compare/v${major}.${minor}?version=${toDesignElementVersionLabel(
    item,
  )}`;
};
